module.exports = __webpack_public_path__ + "img/trash.d2241cc0.svg";